// extracted by mini-css-extract-plugin
export default {"AfterNinthGrade":"AfterNinthGrade_AfterNinthGrade__pK-CG","AfterNinthGradeContainer":"AfterNinthGrade_AfterNinthGradeContainer__y2njr"};